import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { SplitWords, FadeSlideIn } from './AnimatedText';
import { TEST_IDS } from '@/constants/testIds';

export default function CtaSection() {
  return (
    <section
      id="cta"
      data-testid={TEST_IDS.ctaSection}
      className="bg-[#E8E0D5] py-32 md:py-40 px-6 relative overflow-hidden"
    >
      <div className="max-w-3xl mx-auto text-center relative z-10">
        <FadeSlideIn>
          <p className="text-xs md:text-sm uppercase tracking-[0.2em] text-[#C9A96E] font-sans font-semibold mb-8">
            Take the First Step
          </p>
        </FadeSlideIn>

        <h2
          data-testid={TEST_IDS.ctaHeadline}
          className="font-serif text-4xl sm:text-5xl md:text-6xl leading-[1.1] tracking-tighter text-[#1B2A4A] mb-8"
        >
          <SplitWords delay={0.1}>Ready for Your Breakthrough?</SplitWords>
        </h2>

        <FadeSlideIn delay={0.5}>
          <p className="text-base md:text-lg text-[#2D2D2D]/60 font-sans leading-relaxed mb-12 max-w-xl mx-auto">
            Most leaders wait too long. The right time to address what's holding you back is now. One conversation can change everything.
          </p>
        </FadeSlideIn>

        <FadeSlideIn delay={0.7}>
          <motion.a
            href="mailto:hello@luminouscoaching.com"
            data-testid={TEST_IDS.ctaButton}
            className="bg-[#D4853A] text-white px-10 py-5 uppercase text-sm tracking-widest font-sans font-medium hover:bg-[#1B2A4A] transition-colors duration-300 inline-flex items-center justify-center gap-3"
            whileHover={{ scale: 1.03, y: -2 }}
            whileTap={{ scale: 0.98 }}
          >
            Book a Conversation
            <ArrowRight className="w-4 h-4" />
          </motion.a>
        </FadeSlideIn>

        <FadeSlideIn delay={0.9}>
          <p className="text-sm text-[#2D2D2D]/35 font-sans mt-8">
            No obligation. Just clarity.
          </p>
        </FadeSlideIn>
      </div>
    </section>
  );
}
